import { ComponentDocs } from "components/docs";
import { ComponentExample } from "components/examples";

const FormCheckboxGroup = () => (
  <ComponentDocs
    name="<Form.CheckboxGroup/>"
    entry="CheckboxGroup"
    propsEntry="CheckboxGroupProps"
    namespace="FormFields"
  >
    <ComponentExample
      name="Checkbox options"
      import={import("examples/Forms/FormCheckboxGroup/CheckboxOptionsExample")}
      rawImport={import(
        "examples/Forms/FormCheckboxGroup/CheckboxOptionsExample?raw"
      )}
    />
    <ComponentExample
      name="Inline checkboxes"
      import={import(
        "examples/Forms/FormCheckboxGroup/InlineCheckboxesExample"
      )}
      rawImport={import(
        "examples/Forms/FormCheckboxGroup/InlineCheckboxesExample?raw"
      )}
    />
    <ComponentExample
      name="Lookup-connected checkboxes"
      import={import(
        "examples/Forms/FormCheckboxGroup/LookupConnectedCheckboxesExample"
      )}
      rawImport={import(
        "examples/Forms/FormCheckboxGroup/LookupConnectedCheckboxesExample?raw"
      )}
    />
  </ComponentDocs>
);

export default FormCheckboxGroup;
